import { render, staticRenderFns } from "./ReportCaja.vue?vue&type=template&id=1195d506&scoped=true"
import script from "./ReportCaja.vue?vue&type=script&lang=js"
export * from "./ReportCaja.vue?vue&type=script&lang=js"
import style0 from "./ReportCaja.vue?vue&type=style&index=0&id=1195d506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1195d506",
  null
  
)

export default component.exports